export const useUserActivityListener = (eventHandler: () => void) => {
    const userEvents = [
        'mousedown',
        'mousemove',
        'wheel',
        'keydown',
        'touchstart',
        'scroll',
    ]

    const subscribeToUserActivity = () => {
        for (const event of userEvents) {
            window.removeEventListener(event, eventHandler)
            window.addEventListener(event, eventHandler, {
                passive: true,
            })
            // window.addEventListener(event, captureUserActivity)
        }
    }

    const unsubscribeUserActivityListener = () => {
        for (const event of userEvents) {
            window.removeEventListener(event, eventHandler)
        }
    }

    return {
        subscribeToUserActivity,
        unsubscribeUserActivityListener,
    }
}
